import { initTabs } from '../../shared/init-tabs';

initTabs('.wp-block-knightowl-blocks-tabs', '.wp-block-knightowl-blocks-tabs-item');
